const hasOwnProperty = Object.prototype.hasOwnProperty;

function deepEqual(objA, objB) {
    if (Object.is(objA, objB)) {
        return true;
    }

    if (
        typeof objA !== 'object' ||
        objA === null ||
        typeof objB !== 'object' ||
        objB === null
    ) {
        return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    for (let key of keysA) {
        if (
            !hasOwnProperty.call(objB, key) ||
            !deepEqual(objA[key], objB[key])
        ) {
            return false;
        }
    }

    return true;
}

export default deepEqual;


// WEBPACK FOOTER //
// ./src/components/shared/deepEqual.js